import { render } from "./OrderItemsRow.vue?vue&type=template&id=0db5ba53&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml"
import script from "./OrderItemsRow.vue?vue&type=script&lang=js"
export * from "./OrderItemsRow.vue?vue&type=script&lang=js"

import exportComponent from "/home/oawms/app/ru_releases/20261004163500/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QTr from 'quasar/src/components/table/QTr.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTr,QTd,QCheckbox});
